module.exports = __webpack_public_path__ + "img/ico-pending-verification.100f888e.svg";